// You can conbine multiple flags.
export enum EventVisibility {
  PUBLIC = 'p', // event is visible to everyone
  UNLISTED = 'ul', // anyone with the termín's link; not listed on the public page (docs/events.md, _Visibility_)
  CUSTOMERS = 'c', // event is visible only to registered customers
  GROUPS = 'g', // event is visible only to selected groups
  USERS = 'u', // event is visible only to selected users
  PRIVATE = 'pr', // event is visible only to managers
}
